import { Video } from './schema.design';
export type ø = any;
export type Article =
  | LotOverview
  | Projects
  | ContentfulLotSpecsData
  | ILotAttachments
  | LotVideos
  | LotAppointments
  | LotSalesSupport
  | LotAddedServices

export type Image = {
  description: string
  title: string
  url: string
}

export type Icon = {
  url: string
}

export interface IconValue {
  title: string
  id: string
  icon: Icon
}

export interface Project {
  __typename: 'Project'
  title: string
  description: string
  category: string[]
  icon: {
    url: string
    title: string
  }
}
export interface Projects {
  __typename: 'Projects'
  title: string
  projectsCollection: {
    items: Project[]
  }
}
interface LotAddedServices {
  __typename: 'LotAddedServices'
  title: string
  servicesCollection: {
    items: Service[]
  }
}
export interface Service {
  title: string
  description: string
  url: string
  image: Image
  logo: {
    description: string
    title: string
    url: string
  }
}

interface LotSalesSupport {
  __typename: 'LotSalesSupport'
  title: string
  contactTitle: string
  phone: string
  email: string
  icon: {
    title: string
    url: string
  }
}
interface LotOverview {
  __typename: 'LotOverview'
  label: string
  lotPropertiesCollection: {
    items: IconValue[]
  }
}
interface LotAppointments {
  __typename: 'LotAppointments'
  title: string
  modalButtonText: string
  modalButtonTextNoUpcoming: string
  collectionDescription?: {
    json: null | object
  }
  inspectionDescription?: {
    json: null | object
  }
}

export interface LotVideos {
  __typename: 'LotVideos'
  title: string
  linksCollection: {
    items: Video[]
  }
}

export type ContentfulFile = {
  fileName: string
  url: string
  title: string
  contentType: string
}

export interface ILotAttachments {
  __typename: 'LotAttachments'
  title: string
  attachmentsCollection: {
    items: ContentfulFile[]
  }
  iconsCollection: {
    items: ContentfulFile[]
  }
}

export interface ContentfulLotTemplate {
  calloutCollection: {
    items: {
      name: string
      enabled: boolean
    }[]
  }
  lotPageCollection: {
    items: {
      sys: { id: string }
      slug: string
      label: string
      galleryVariant: 'modern' | 'classic' | 'compact'
      paymentColumnCollection: {
        items: { title: string; projectsCollection: { items: Project[] } }[]
      }
      lotTopSectionCollection: { items: Article[] }
      contentColumnSectionCollection: { items: Article[] }
      bottomFullSectionCollection: { items: Article[] }
    }[]
  }
}

export interface LotQuery {
  lotSku: string;
  category: string | null;
  name: string | null;
  lotId: string;
  saleId: string;
}

export interface LotPageParams {
  lotSku: string;
  slugs?: [string | undefined, string | undefined];
}

export interface ContentfulLotSpecsData {
  __typename: 'LotKeySpecs';
  title: string;
  specsCollection: {
    items: IconValue[];
  };
}

export type GroupArticles = {
  mainCol: Article[];
  bottom: Article[];
};

export enum DeliveryType {
  Unknown = 'Unknown',
  PickupOnly = 'Pick up only',
  Limited = 'Limited',
  NationWide = 'Nation wide',
}